import { render, staticRenderFns } from "./homePage4.vue?vue&type=template&id=03c16688&scoped=true"
import script from "./homePage4.vue?vue&type=script&lang=js"
export * from "./homePage4.vue?vue&type=script&lang=js"
import style0 from "./homePage4.vue?vue&type=style&index=0&id=03c16688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c16688",
  null
  
)

export default component.exports